import { useLogging } from '../../provider/logging/Logging.hook.ts';
import ErrorBoundary from './ErrorBoundary.tsx';
import type { ErrorBoundaryWrapperProperties } from './ErrorBoundary.wrapper.properties.ts';

const ErrorBoundaryWrapper = (props: ErrorBoundaryWrapperProperties) => {
  const { logError, logTrace } = useLogging();

  return <ErrorBoundary {...props} logError={logError} logTrace={logTrace} />;
};

export default ErrorBoundaryWrapper;
